import { ImCross } from "react-icons/im";

const NoAccess = ({ isLicenseError = false, customErrorText = '' }) => {
    const generateContent = () => {
        if (customErrorText.trim() !== '') {
            return <span className='mt-5'>{customErrorText}</span>
        }
        else {
            return (<>
                <span className='mt-5'>Brak uprawnień do przeglądania tej zawartości!</span>
                {isLicenseError && <span>Niezgodnośc licencji!</span>}
                <span>Skontaktuj się z administratorem strony</span>
            </>)
        }
    }
    return (
        <div className="container main-container-holder">
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ fontSize: '25px' }}>
                <ImCross size={150} className='error-text-color' />
                {generateContent()}
            </div>
        </div>
    )
}

export default NoAccess